import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=1373c2b4&scoped=true&"
import script from "./VirtualList.vue?vue&type=script&lang=ts&"
export * from "./VirtualList.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualList.vue?vue&type=style&index=0&id=1373c2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373c2b4",
  null
  
)

export default component.exports